export enum HHServiceLineAuthorizationLevel {
  Active = 'Active',
  Incomplete = 'Incomplete',
  Discharged = 'Discharged',
  Cancelled = 'Cancelled',
}

export interface HHServiceLine {
  additionalInformationReceived: null;
  authorizationId: string;
  authorizationNumber: string;
  authorizationStatus: string;
  authorizationType: string;
  clinicalReviewStartDate: string;
  clinicalReviewAdjudicationDate: string;
  hasAssignedLiaison: string;
  hcpcCode: string;
  isEscalatedCase: boolean;
  isInitialRequest: boolean;
  isMemberC3: string;
  isQualityCheckComplete: boolean;
  isWoundOstomyAdmitted: string;
  isWccWarning: boolean;
  hasNewClinicalResponse: boolean;
  authorizationLevel: HHServiceLineAuthorizationLevel;
  memberId: string;
  memberName: string;
  memberState: string;
  memberSubscriberNumber: string;
  orderSubtype: string;
  providerAccountId: string;
  providerName: string;
  providerNpi: string;
  providerPgpId: string;
  providerPostalState: string;
  reimbursementAbbreviation: string;
  requestReceivedDate: string;
  anticipatedManualDecisionDate: string;
  decisionPeriod:number;
  requestType: string;
  routedDate: string;
  secondLevelReview: string;
  serviceLineCreatedBy: string;
  serviceLineId: string;
  serviceLineQueueId: string;
  serviceLineStatus: string;
  serviceLineStatusReason: string;
  serviceNumber: number;
  skillCode: string;
  staffingStatus: string;
  tenantName: string;
  urgency: string;
  user: {
    email: string;
    userId: string;
    name: string;
  },
  outreachReasons: string[];
}

export type HHServiceLineDTO = Partial<HHServiceLine>;

export interface HHServiceLineResponse {
  items: HHServiceLineDTO[];
  count: number;
}
